import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { ApiService } from 'src/app/core/services/api.service';
import { environment } from 'src/environment/environment';
import { normalizePermission, Permission, PermissionsResponse } from '../models/permissions.model';

@Injectable({ providedIn: 'root' })
export class PermissionsApiService extends ApiService {
  getMyPermissions$(): Observable<Permission[]> {
    return this.get<PermissionsResponse>('/Permissions/me').pipe(map(normalizePermissionsResponse));
  }

  getPermissions$(): Observable<Permission[]> {
    return this.get<PermissionsResponse>('/Permissions').pipe(map(normalizePermissionsResponse));
  }
}

function normalizePermissionsResponse(response: PermissionsResponse): Permission[] {
  const permissions = Array.isArray(response)
    ? response
    : response.permissions || response.data || response.items || response.results || [];

  return permissions.map((permission, index) => normalizePermission(permission, index));
}

export const apiPermissionsProtectedResources = [
  {
    httpMethod: 'GET',
    scopes: [...environment.protectedResources.apiPermissions.scopes.read],
  },
];